import { Component, computed, inject, input } from '@angular/core';
import { SpriteManagerService } from '@app/shared/services/sprite-manager.service';
import { ThemingService } from '@app/shared/services/theming.service';

@Component({
  selector: 'slotcom-hall-item',
  templateUrl: './hall-item.component.html',
  styleUrls: ['./hall-item.component.scss'],
  standalone: true,
})
export class HallItemComponent {
  trophy = input.required<string>();
  total = input<number>(0);

  private themingService = inject(ThemingService);
  private spriteManager = inject(SpriteManagerService);

  isDisabled = computed(() => this.total() === 0);

  trophyImage = computed(() => this.themingService.getThemeAsset('none', `pl-trophy-${this.trophy()}`));
  ribbonImage = computed(() => this.spriteManager.getImage('/images/shared/trophies/view/banderin.png'));
}
